import React, { Component, ChangeEvent, ReactNode } from 'react';
import classNames from 'classnames';
import Data from '../../../../../../model/Data';
import './Select-md.css';
import './Select-lg.css';
import './Select-xs.css';

interface Props {
  dataName: string,
  placeholder?: string,
  className?: string,
  value?: {id: string, label: string},
  options: Array<{id: string, name: string}>,
  onChange?: (ev: ChangeEvent<HTMLSelectElement>) => void
}

export default class Select extends Component<Props, {isToggleOn: boolean}> {
  private placeholder: string;

  private currentClass = 'custom-select';

  private defaultText = 'Выберите';

  private defaultPlaceholder = 'Откуда узнали о программе Учи+1';

  constructor(props: Props) {
    super(props);
    const { placeholder } = this.props;
    this.state = {
      isToggleOn: false,
    };
    this.placeholder = placeholder ? placeholder : this.defaultPlaceholder;
    this.onChange = this.onChange.bind(this);
  }

  private sourceNameById(id: string): string {
    if (id === '') return this.defaultText;
    const { options } = this.props;
    return options.filter((s) => s.id === id)[0].name;
  }

  private onChange(ev: ChangeEvent<HTMLSelectElement>) {
    ev.persist();

    const { onChange } = this.props;
    const newValue = ev.currentTarget.value;
    this.setState((prevState) => ({...prevState, value: newValue}))
    if (typeof onChange === 'function' ) onChange(ev);
  }

  render(): ReactNode {

    const { className, options, dataName, value } = this.props;
    const wrapperKlass = {
      [this.currentClass]: true,
    };
    let valueText = value?.label || this.defaultText;

    if (value?.label && (value.label !== '')) {
      wrapperKlass['has-value'] = true;
    }
    if (className) wrapperKlass[className] = true;

    const optionViews = options.map((source: {id: string, name: string}) => (
      <option
        key={`option-view-${source.id}`}
        value={source.id}
      >
        {source.name}
      </option>
    ));

    return (
      <div className={classNames(wrapperKlass)}>
        <select name={dataName} id={dataName} onChange={ this.onChange }>
          <option hidden disabled selected></option>
          { optionViews }
        </select>

        <div className="value">{ valueText }</div>
        <div className="placeholder">{ this.placeholder }</div>
        <div className="arrow"></div>
      </div>
    );
  }
}
